module.exports = __webpack_public_path__ + "static/img/sync.3e647c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sync.png
// module id = 390
// module chunks = 1